// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { addListener, removeListeners } from "~/lib/signals";
import { CONFIG } from "~/config";
import { resolveTitleCollision, resolveDetailCollision, moveMarkerOnSamePlace } from "./collision";
import Scene from "~/scene";
import { isDetailActive } from "~/util/detail";
import { store } from "~/state/store";
import { getBadgeComponent, reviewHasColoredBadge, reviewHasGreenBadge } from "~/util/review";
import { description, getIcon } from "~/util/providers/poiagg";
import SceneCoords from "~/scene/common/coords";
import ControlPointer from "~/ui/controls/pointer";
import mapControls from "~/scene/control/mapcontrols";
import { getPointerCenterPx, getPointerDistance } from "~/util/pointer";
import { watch, watchCoordinates } from "~/state/util";
import { Unsubscribe } from "redux";
import WasmStoreMarker from "~/wasm/store/wasm-store-marker";
import { IPoi } from "~/interfaces";
import { getMarkerImgFrompoi } from "~/util/wasm";
import WasmHiddenPois from "~/wasm/hidden-pois";
import { WASM_ZINDEX } from "~/wasm/const";
import WasmStoreHandler from "~/wasm/store/store-handler";
import { TMarkerType } from "~/wasm/store/interfaces";
import WasmBulkMode from "~/wasm/store/bulk-mode";
import { hidePopup, popupSearch } from "~/wasm/controller/util";

export const addBadge = (poi, element) => {
	if (poi.review && reviewHasColoredBadge(poi.review)) {
		element.appendChild(node(getBadgeComponent(), {
			rating: poi.review.review_rating_stars,
			top: Mapy.CUS.userweb.badgeWCMapGreen || reviewHasGreenBadge(poi.review),
			size: "small",
		}));

		return true;
	}

	return false;
}

export default class Markers {
	_drop: ControlPointer;

	_wasmMarkers: Array<WasmStoreMarker>;

	_curWasmMarkers: { [key: string]: WasmStoreMarker };

	_wasmHiddenPois: WasmHiddenPois;

	_detailMarker: WasmStoreMarker | null;

	/**
	 * @param {Search} search Instance Search s vysledky hledani (kvuli parovani)
	 */
	constructor(search, fromHistory, {
		redrawCb = () => {},
		markerStateCb = () => {},
	}) {
		this._query = search.getMeta().noLocQuery || search.getQuery();

		var correction = Mapy.getComponent("search").correction;
		var opts = search.getOptions();

		this._options = {
			page: -1,
			limit: parseInt(Mapy.CUS.search?.searchLimit || 200),
			filter: true,
			listCategory: opts.listCategory || 0,
			filterMultimarker: SMap.WMMarker.getFilterMultimarker(),
			correction: {
				correctedQuery: correction.correctedQuery,
				status: correction.status,
				shouldQuery: correction.shouldQuery,
				correctorId: correction.correctorId,
			}
		};

		this._setFilters();

		this._wasmMarkers = [];
		this._curWasmMarkers = {};
		this._active = false;
		this._layer = Mapy.getComponent("masakovac");
		this._markers = [];
		this._markersBBox = [];
		this._sc = [];
		this._storeUnsubscribe = null;
		this._results = []; /* individualni vysledky */
		this._rightResultsObj = {}; // ID vysledku vpravo v obj
		this._rightResultsHoverObj = {}; // ID vysledku vpravo v obj pro hover
		this._recurSendCount = 1;
		this._search = search;
		this._savedSearch = search;
		this._drop = new ControlPointer({
			type: "red",
			showCaption: true,
			countAlwaysShow: true,
		});
		mapControls.addControlPointer(this._drop);

		this._fromHistory = fromHistory;
		this._interaction = true;
		this._disable = false;
		this._redrawCb = redrawCb;
		this._markerStateCb = markerStateCb;
		this._redrawData = {
			id: null,
			timeout: 600,
			forceTimeout: 100,
		};
		this._centerZoom = null;
		this._detailMarker = null;
		this._wasmHiddenPois = Mapy.getComponent("wasm").createHiddenPoiList("searchPois");
		// pokud je vzdalenost mensi jak 20% velikosti obrazovky, tak se neposila signal map redraw
		this._MIN_DISTANCE_RATIO = 0.2;

		this._sc.push(addListener(this, "search-item-enter", "_searchItemEnter"));
		this._sc.push(addListener(this, "search-item-leave", "_searchItemLeave"));

		this._sc.push(addListener(this, "detail-activated", "_detailActivated"));
		this._sc.push(addListener(this, "detail-deactivated", "_detailDeactivated"));

		// interaktivita u rucniho mereni
		this._sc.push(addListener(this, "distancemeter-activated", "_disableInteraction"));
		this._sc.push(addListener(this, "distancemeter-deactivated", "_enableInteraction"));
		// vlastni body
		this._sc.push(addListener(this, "usermarks-activated", "_disableSearch"));
		this._sc.push(addListener(this, "usermarks-deactivated", "_enableSearch"));
		// gpx
		this._sc.push(addListener(this, "gpx-activated", "_disableSearch"));
		this._sc.push(addListener(this, "gpx-deactivated", "_enableSearch"));
		// userprofile
		this._sc.push(addListener(this, "userprofile-activated", "_disableSearch"));
		this._sc.push(addListener(this, "userprofile-deactivated", "_enableSearch"));
	}

	destroy() {
		this._active = false;
		this.stopListen();

		if (this._search) {
			this._search.abort();
			this._search = null;
		}

		if (this._redrawData.id) {
			clearTimeout(this._redrawData.id);
			this._redrawData.id = null;
		}

		this._results = [];
		this._layer.removeAll("search");
		this._centerZoom = null;
		this._detailMarker = null;

		this._storeUnsubscribe?.();
		this._storeUnsubscribe = null;
		removeListeners(this._sc);
		mapControls.removeControlPointer(this._drop);

		while (this._markers.length) {
			var marker = this._markers.pop();
			marker.destroy();
		}

		const wasmBulk = new WasmBulkMode();

		for (const wasmMarker of this._wasmMarkers) {
			wasmBulk.removeMarker(wasmMarker);
		}

		wasmBulk.run();

		this._wasmMarkers.length = 0;
		this._curWasmMarkers = {};
		this._wasmHiddenPois.clear();
		this._wasmHiddenPois.updateWasm();
	}

	activate() {
		if (this._active) { return this; }

		const { longitude, latitude, zoom } = store.getState().map;

		this._active = true;
		this._recurSendCount = 1;
		this._centerZoom = [Scene.coordsFromWGS84(longitude, latitude), zoom];

		this._enableInteraction();

		// byl proveden zoom?
		var meta = this._savedSearch.getMeta();

		for (var i = 0; i < this._markers.length; i++) {
			var marker = this._markers[i];
			var source = marker.getSource();
			var id = marker.getPlainId();
			this._layer.addMarker("search", marker, source, id, true);
		}

		if (this._markers.length) {
			this._layer.redraw(false);
		}

		this._wasmMarkersVisibility(true);

		Scene.removeCard();

		this._done();

		return this;
	}

	deactivate() {
		if (!this._active) { return this; }

		this._active = false;

		for (var i = 0; i < this._markers.length; i++) {
			var marker = this._markers[i];
			this._layer.removeMarker(marker, true);
		}

		this._wasmMarkersVisibility(false);
		this._layer.redraw(false);

		this._recurSendCount = 1;

		this._storeUnsubscribe?.();
		this._storeUnsubscribe = null;

		return this;
	}

	getLayer() {
		return this._layer;
	}

	setSearch(search) {
		this._search = search;
		this._done();
	}

	clearSearchTimeout() {
		if (this._redrawData.id) {
			clearTimeout(this._redrawData.id);
			this._redrawData.id = null;
		}
	}

	startListen(setCenterZoom) {
		if (setCenterZoom) {
			const { longitude, latitude, zoom } = store.getState().map;

			this._centerZoom = [new SceneCoords(Scene, longitude, latitude), zoom];
		}

		if (!this._storeUnsubscribe) {
			const wt = watch(store.getState, "map", watchCoordinates);

			this._storeUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
				if (
					newMap.longitude !== oldMap.longitude
					|| newMap.latitude !== oldMap.latitude
					|| newMap.zoom !== oldMap.zoom
				) {
					this._mapRedraw();
				}
			}));
		}
	}

	stopListen() {
		this._storeUnsubscribe?.();
		this._storeUnsubscribe = null;
	}

	get redrawData() {
		return this._redrawData;
	}

	get interaction() {
		return this._interaction;
	}

	get disable() {
		return this._disable;
	}

	get isActive() {
		return this._active;
	}

	_done() {
		if (!this._active) { return; }

		// nastavime vysledky
		this._setResults();

		// neprisly zadne vysledky - zobrazuje se 10 zprava -> novy request podle noveho viewportu
		if (!this._resultsCount && this._recurSendCount > 0 && !Mapy.getComponent("search").locCorrection) {
			this._recurSendCount--; // abysme predesli zacykleni

			return;
		}

		this._prepareData();

		this._search = null;
	}

	_prepareData() {
		var markersArray = [];
		var detailActive = isDetailActive(store.getState());
		this._markersBBox = [];
		let movedCoords = [];

		if (!this._active) { return; }

		if (Scene.isM3dActive()) {
			this._layer.removeMarker(this._markers, true);

			while (this._markers.length) {
				var prevMarker = this._markers.pop();
				// FIXME nevim zda je spravne tu kartu odebirat
				prevMarker.removeCard();
				prevMarker.destroy();
			}
		}

		this._wasmHiddenPois.clear();

		var query = Mapy.getComponent("search").getState().q || "";
		const curIds = Object.keys(this._curWasmMarkers);
		const newWasmMarkers: Array<WasmStoreMarker> = [];
		const wasmBulk = new WasmBulkMode();

		for (var i = this._results.length-1; i >= 0; i--) {
			const poi = this._results[i];

			const wasmData = {
				caption: "",
				reviewValue: poi.review && reviewHasColoredBadge(poi.review)
					? poi.review.review_rating_stars
					: 0,
				reviewActive: Mapy.CUS.userweb.badgeWCMapGreen || (poi.review && reviewHasGreenBadge(poi.review)),
			};

			this._wasmHiddenPois.addPoi(poi.source, poi.id);

			var markerId = poi.source + "_" + poi.id;
			var markerOpts = {
				onlyIconOnSmall: true,
			};

			if (markerId in this._rightResultsObj) {
				markerOpts.alwaysVisible = true; // pro 3d

				if (["middle", "big"].indexOf(poi.markerId) === -1) {
					poi.markerId = "small";
				}
			}
			else {
				poi.markerId = "little";
			}

			const wasmInd = curIds.indexOf(markerId);

			if (wasmInd !== -1) {
				curIds.splice(wasmInd, 1);
			}

			if (this._options.correction && this._options.correction.correctorId === 4) {
				markerOpts.qc = poi.correctedResult ? this._options.correction.correctedQuery : query;
			}

			// titulek k markeru
			const descElm = node("div", { className: "poi-desc" });
			const titleCont = node("div", { className: "poi-title" });
			const title = node("span", {}, poi.title != "" ? poi.title : poi.firstRow);

			wasmData.caption = poi.title != "" ? poi.title : poi.firstRow;
			titleCont.append(title)
			descElm.append(titleCont);

			if (Mapy.CUS.search?.titleTextBlockWidth) {
				titleCont.style.width = `${parseInt(Mapy.CUS.search?.titleTextBlockWidth)}px`;
			}

			// hvezdicky - 3 vazeny prumer
			addBadge(poi, descElm);
			markerOpts.elm = descElm;
			markerOpts.onlyElm = false;

			let marker = Scene.createMarkerMapyWindySearchFromPOI(poi, undefined, markerOpts);

			if (detailActive) {
				marker.setActive(false);
				marker.setInteractive(true);
			}

			if (markerId in this._curWasmMarkers) {
				newWasmMarkers.push(this._curWasmMarkers[markerId]);
			} else {
				const url = getMarkerImgFrompoi(poi);
				let type: TMarkerType = poi.markerId === "big"
					? "big"
					: poi.markerId === "little"
						? "little"
						: "search-badge-text";

				if (!url) {
					if (type === "search-badge-text") {
						type = "small-universal";
					} else if (type === "big") {
						type = "big-universal";
					}
				}

				const wasmMarker = wasmBulk.createMarker({
					type,
					lon: poi.mark.lon,
					lat: poi.mark.lat,
					visual: detailActive
						? "inactive"
						: "standard",
					zIndex: poi.markerId === "big"
						? WASM_ZINDEX.marker.searchBig
						: poi.markerId === "little"
							? WASM_ZINDEX.marker.searchLittle
							: WASM_ZINDEX.marker.searchSmall,
					interactionType: "click-hover",
					hover: poi.markerId === "little"
						? {
							type: "small",
							zIndex: WASM_ZINDEX.marker.searchHover,
						}
						: null,
					customData: {
						url,
						customId: markerId,
						order: i,
						caption: wasmData.caption,
						review: {
							...wasmData.reviewValue > 0
								? {
									value: wasmData.reviewValue,
									active: wasmData.reviewActive,
								}
								: {},
						},
						poi: {
							source: poi.source,
							id: poi.id,
						},
						component: "search",
					},
				});

				this._curWasmMarkers[markerId] = wasmMarker;
				newWasmMarkers.push(wasmMarker);
			}

			if (!CONFIG.inFrame) {
				// protoze na signaly enter a leave markeru se ve spojeni s card neda spolehnout, vlastni implementace enter a leave
				marker.getContainer(cont => {
					let callback = state => {
						if (state === "enter") {
							marker.isBlurring = false;
							if (poi.markerId === "little" && !marker.hasChagedType) {
								if (!(poi.review && reviewHasColoredBadge(poi.review)) && !poi.unreviewed) {
									description([poi], {
										reviews: true,
									}).then(function(data) {
										marker.setType("small");
										marker.hasChagedType = true;
										marker.setActive(!isDetailActive(store.getState()));
										marker.setInteractive(true);
										if (addBadge(data.poi[0], cont)) {
											poi.review = data.poi[0].review;
										} else {
											poi.unreviewed = true;
										}
									}, () => {});
								} else {
									marker.setType("small");
									marker.hasChagedType = true;
									marker.setActive(!isDetailActive(store.getState()));
									marker.setInteractive(true);
									addBadge(poi, cont);
								}
							}
							setTimeout(() => {
								const card = marker.getCard();
								if (card) {
									const bottom = parseFloat(card.style.bottom);
									const top = parseFloat(cont.style.top);
									const anchor = marker.getCardAnchor(poi.markerId === "little" ? "small" : poi.markerId);
									if (bottom + top - anchor < -5) {
										card.style.zIndex = "101";
									}
								}
							}, 350);
						}

						// FIXME deje se i pri prejizdeni z markeru na kartu, coz je zbytecny
						if (state === "leave") {
							marker.isBlurring = true;
							setTimeout(() => {
								if (marker.isBlurring) {
									if (marker.hasChagedType) {
										marker.setType("little");
										delete marker.hasChagedType;
										marker.setActive(!isDetailActive(store.getState()));
									}
									const card = marker.getCard();
									if (card) {
										card.style.zIndex = null;
									}
									delete marker.isBlurring;
								}
							}, 200);
						}

						this._markerStateCb({
							state,
							source: poi.source,
							id: poi.id,
						});
					}

					cont.addEventListener("mouseenter", e => {
						cont.style.zIndex = "100";
						let card = marker.getCard();

						callback("enter");

						if (card.dataset.listen !== "1") {
							card.addEventListener("mouseenter", e => {
								callback("enter");
							});
							card.addEventListener("mouseleave", e => {
								callback("leave");
							});

							card.dataset.listen = "1";
						}
					});

					cont.addEventListener("mouseleave", e => {
						cont.style.zIndex = null;
						callback("leave");
					});
				});
			}

			if (markersArray.length) {
				let result = moveMarkerOnSamePlace(marker, markersArray, movedCoords);

				movedCoords = result.movedCoords;

				if (result.markerPadding) {
					marker.paddingPosition = result.markerPadding;
				}
			}

			markersArray.push(marker);

			this._markersBBox.push({
				marker: marker.getBBox(),
			});
		}

		for (const id of curIds) {
			wasmBulk.removeMarker(this._curWasmMarkers[id]);
			delete this._curWasmMarkers[id];
		}

		this._wasmMarkers = newWasmMarkers;
		this._wasmHiddenPois.updateWasm();

		wasmBulk.run();

		markersArray.reverse();
		this._markersBBox.reverse();

		for (let i = 0; i < markersArray.length; i++) {
			const m = markersArray[i];
			const poi = m.getPOI();
			this._layer.addMarker("search", m, poi?.source, poi?.id, true);
		}

		this._layer.removeMarker(this._markers, true);

		for (let i = 0; i < this._markers.length; i++) {
			let prevMarker = this._markers[i];
			// FIXME nevim zda je spravne tu kartu odebirat
			Scene.isMapActive() && prevMarker.removeCard();
			prevMarker.destroy();
		}

		this._markers = [];

		Scene.removeCard();

		this._markers = markersArray;

		const markersToRemove = resolveTitleCollision(this._markers, this._markersBBox);
		markersToRemove.length && this._layer.removeMarker(markersToRemove, true);

		if (CONFIG.isScreenshoter) {
			this._layer.redraw();
		} else {
			requestAnimationFrame(() => {
				this._layer.redraw();
			});
		}
	}

	_mapRedraw(e) {
		if (this._redrawData.id) {
			clearTimeout(this._redrawData.id);
			this._redrawData.id = null;
		}

		let search = Mapy.getComponent("search");

		this._redrawData.id = setTimeout(() => {
			this._redrawData.id = null;

			/* jen pokud jsme aktivni */
			if (!this._active || this._disable || !this._centerZoom || typeof this._redrawCb != "function") return;

			const { longitude, latitude, zoom } = store.getState().map;
			const center = new SceneCoords(Scene, longitude, latitude);
			let diff = Scene.coordsToPixel(this._centerZoom[0]).minus(Scene.coordsToPixel(center));
			let dist = Math.sqrt(diff.x * diff.x + diff.y * diff.y);
			let size = Scene.getSize();
			let lowerSide = Math.min(size.x, size.y);

			// zmena zoomu nebo je vzdalenost vetsi jak 20% mensi strany obrazovky
			if (zoom != this._centerZoom[1] || dist / lowerSide >= this._MIN_DISTANCE_RATIO) {
				this._centerZoom = [center, zoom];
				this._redrawCb();
			}
		}, this._redrawData[search.forceMarkersLoad ? "forceTimeout" : "timeout"]);
	}

	_highlight(e, state) {
		if (Scene.isMapActive()) {
			// wasm
			if (CONFIG.wasmEnabled) {
				// FIXME: docasne zakomentovano, protoze to nestihnu doladit, nez se to bude prezentovat
				// ukazujeme
				if (state) {
					const source = e.data.source;
					const id = e.data.id;
					const { markers } = store.getState().mapContent;
					const wasmMarker = markers.find(marker => {
						const poi = marker.customData?.poi;

						if (poi?.id === id && poi?.source === source) {
							return true;
						}

						return false;
					});

					wasmMarker && popupSearch(wasmMarker, Mapy.getComponent("wasm").wasm);
				// schovavame
				} else {
					hidePopup();
				}
			} else {
				const source = e.data.source;
				const id = e.data.id;
				const markerData = this.getMarker(source, id);
				const marker = markerData.marker;
				const mCoords = marker?.getCoords();

				if (!mCoords) {
						return;
				}

				if (state) {
					if (Scene.coordsInMap(mCoords)) {
						marker.showCard(undefined, true);
					}

					this._drop.setPosition(() => {
						const { longitude, latitude } = store.getState().map;

						return {
							position: getPointerCenterPx(mCoords),
							caption: getPointerDistance(Scene.coordsFromWGS84(longitude, latitude), mCoords),
							alwaysShow: this._isMarkerOnTheEdge(marker),
						};
					});
				}
				else {
					if (Scene.coordsInMap(mCoords)) {
						marker.removeCard();
					}

					this._drop.setPosition(null);
				}
			}
		} else {
			var source = e.data.source;
			var id = e.data.id;
			var markerData = this.getMarker(source, id);
			var marker = markerData.marker;
			var detailActive = isDetailActive(store.getState());

			for (var i = 0; i < this._markers.length; i++) {
				this._markers[i].setActive(!state && !detailActive);
				this._markers[i].setFocus();
			}

			// missing marker
			if (markerData.isMissing) {
				// zobrazime kapicku + highlight
				if (state) {
					this._layer.addMarker("search", marker, source, id);

					setTimeout(function() {
						marker.setActive(true);
						marker.setFocus(true);
					}, 10);

					this._drop.setPosition(() => {
						const { longitude, latitude } = store.getState().map;

						return {
							position: getPointerCenterPx(marker.getCoords()),
							caption: getPointerDistance(Scene.coordsFromWGS84(longitude, latitude), marker.getCoords()),
						};
					});
				} else {
					// skryjeme kapicku + highlight
					this._layer.removeMarker(marker);
				}
			} else if (marker) {
				// standard
				if (state) {
					marker.setActive(true);
					marker.setFocus(true);
				}

				var alwaysShow = false;

				if (["big", "middle"].indexOf(marker.getType().name) == -1) {
					alwaysShow = this._isMarkerOnTheEdge(marker);
				}

				this._drop.setPosition(() => {
					const { longitude, latitude } = store.getState().map;

					return {
						position: getPointerCenterPx(marker.getCoords()),
						caption: getPointerDistance(Scene.coordsFromWGS84(longitude, latitude), marker.getCoords()),
					};
				});
			}

			if (!state) {
				this._drop.setPosition(null);
			}
		}
	}

	/**
	 * Nachazi se marker na okraji obrazovky?
	 *
	 * @param  {Object}  marker
	 * @return {Boolean}
	 */
	_isMarkerOnTheEdge(marker) {
		// konstanta ramecku v [px]
		var THRESHOLD = 20;
		var px = Scene.coordsToPixel(marker.getCoords());
		var size = Scene.getSize();
		var x = Math.floor(size.x / 2 + px.x);
		var y = Math.floor(size.y / 2 + px.y);

		return (x < THRESHOLD || x >= size.x - THRESHOLD || y < THRESHOLD || y > size.y - THRESHOLD);
	}

	_searchItemEnter(e) {
		this._highlight(e, true);
	}

	_searchItemLeave(e) {
		this._highlight(e);
	}

	_detailActivated() {
		for (let i = 0; i < this._markers.length; i++) {
			this._markers[i].setActive(false);
			this._markers[i].setInteractive(true);
		}

		resolveDetailCollision(this._markers, this._markersBBox);

		const wasmBulk = new WasmBulkMode();

		for (const wasmMarker of this._wasmMarkers) {
			wasmBulk.updateMarker(wasmMarker, {
				visual: "inactive",
			});
		}

		wasmBulk.run();

		// skryjeme vysledek hledani
		const detailData = store.getState().detail.data;

		if (detailData) {
			const filtered = this._wasmMarkers.filter(item => {
				const poi = item.data.customData?.poi;

				if (poi.id === detailData.id && poi.source === detailData.source) {
					return true;
				}

				return false;
			});

			// predesly
			if (this._detailMarker) {
				this._detailMarker.update({
					visible: true,
				});
			}

			if (filtered.length === 1) {
				this._detailMarker = filtered[0];

				this._detailMarker.update({
					visible: false,
				});
			}
		}
	}

	_detailDeactivated() {
		for (let i = 0; i < this._markers.length; i++) {
			this._markers[i].setInteractive(false);
			this._markers[i].setActive(true);
		}

		resolveDetailCollision(this._markers, this._markersBBox);

		const wasmBulk = new WasmBulkMode();

		for (const wasmMarker of this._wasmMarkers) {
			wasmBulk.updateMarker(wasmMarker, {
				visual: "standard",
				...wasmMarker.id === this._detailMarker?.id
					? {
						visible: true,
					}
					: {},
			});
		}

		wasmBulk.run();
	}

	_setResults() {
		if (!this._search) { return; }
		var results = this._search ? this._search.getAllResults() : null;
		this._resultsCount = results ? results.length : 0;
		var all = [];
		var rightResultsItems = this._search ? this._search.getResults() : this._savedSearch.getResults();
		let markerFromRightPanel = [];

		this._rightResultsObj = {};

		// ID vsech vysledku vpravo do pole
		for (let i = 0; i < rightResultsItems.length; i++) {
			const item = rightResultsItems[i];
			this._rightResultsObj[item.source + "_" + item.id] = item;
			markerFromRightPanel.push(item);
		}

		// razeni - jiz je na backendu (jen otocitt poradi pro vykreslovani)
		for (let i = this._resultsCount-1; i > -1; i--) {
			if (this._rightResultsObj[results[i].source + "_" + results[i].id]) {
				this._rightResultsObj[results[i].source + "_" + results[i].id].markerId = results[i].markerId;
			}
			else {
				// pokud neni hidden a neni v pravem panelu, markery pro pravy panel se resi dale
				!results[i].hidden && all.push({ ...results[i] });
			}
		}

		// reseni markeru z praveho panelu, ty jsou v mape vzdy, neproredene
		all = all.concat(markerFromRightPanel.reverse());

		this._results = all;
	}

	/**
	 * Ziskani objektu pro backend, kde jsou ID velikosti slz a jejich velikosti
	 */
	_getFilterMultimarker() {
		return {
			big: {
				width: 50,
				height: 62
			},
			middle: {
				width: 41,
				height: 55
			},
			small: {
				width: 34,
				height: 45,
				maxCount: 30
			},
			little: {
				width: 6,
				height: 6
			}
		};
	}

	/**
	 * Ziska marker pomoci source, id.
	 * Vraci objekt, kde je marker a isMissing, pokud se jedna o chybejici markery, ktere jsou vpravo a nejsou na mape.
	 *
	 * @param  {String} source
	 * @param  {Number} id
	 * @return {Object}
	 */
	getMarker(source, id) {
		var output = {
			marker: null,
			isMissing: false
		};

		for (var i=0; i < this._markers.length;i++) {
			var item = this._markers[i];

			if (source == item.getSource() && id == item.getPlainId()) {
				output.marker = item;
				break;
			}
		}

		if (!output.marker) {
			output.marker = this._rightResultsHoverObj[source + "_" + id];

			if (output.marker) {
				output.isMissing = true;
			}
		}

		return output;
	}

	getWasmMarker(source, id) {
		const filtered = this._wasmMarkers.filter(item => item.data.customData.customId === `${source}_${id}`);

		return filtered.length
			? filtered[0]
			: null;
	}

	_disableInteraction() {
		this._layer.disableInteraction();
		this._interaction = false;
	}

	_enableInteraction() {
		this._layer.enableInteraction();
		this._interaction = true;
	}

	_wasmMarkersVisibility(visible: boolean) {
		const wasmBulk = new WasmBulkMode();

		for (const wasmMarker of this._wasmMarkers) {
			wasmBulk.updateMarker(wasmMarker, {
				visible,
			});
		}

		wasmBulk.run();
	}

	_disableSearch() {
		this._layer.removeAll("search");

		this._disable = true;
		this.stopListen();
		this._wasmMarkersVisibility(false);
	}

	_enableSearch() {
		if (!Mapy.getComponent("search").isActive()) {
			while (this._markers.length) {
				this._markers.pop().destroy();
			}
		}
		else {
			if (!Mapy.Search.hideResults()) {
				for (let i = 0; i < this._markers.length; i++) {
					const marker = this._markers[i];
					this._layer.addMarker("search", marker, marker.getSource(), marker.getPlainId(), true);
				}
			}

			this._layer.redraw();
			this._disable = false;
			this._enableInteraction();
			this.startListen();
			this._wasmMarkersVisibility(true);

			typeof this._redrawCb == "function" && this._redrawCb();
		}
	}

	_setFilters() {
		let filters = Mapy.getComponent("search").getFilters();
		if (Object.keys(filters).length) {
			this._options.filters = [];

			for (let name in filters) {
				this._options.filters.push(filters[name]);
			}
		}
	}
};
